export default __webpack_public_path__ + "static/media/prize-5-cn.5d280efc.webp";